module.exports = __webpack_public_path__ + "static/img/2-03.1de62c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-03.png
// module id = 220
// module chunks = 0